<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Policy
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model.number="form.time"
                label="Time(hours)"
                outlined
                :error-messages="errors.time"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model.number="form.target_value"
                label="Target(Gift value)"
                outlined
                :error-messages="errors.target_value"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model.number="form.host_salary"
                label="Host Salary($9.99)"
                type="number"
                outlined
                :error-messages="errors.host_salary"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model.number="form.agent_salary"
                label="Agent Salary($9.99)"
                type="number"
                outlined
                :error-messages="errors.agent_salary"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model.number="form.bd_salary"
                label="BD Salary($9.99)"
                type="number"
                outlined
                :error-messages="errors.bd_salary"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model.number="form.total_salary"
                label="Total Salary($9.99)"
                type="number"
                outlined
                :error-messages="errors.total_salary"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Policy
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "PolicyIdPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      isLoading: false,
    };
  },
  watch: {
    "form.host_salary": "calculateTotal",
    "form.agent_salary": "calculateTotal",
    "form.bd_salary": "calculateTotal",
  },
  mounted() {
    this.getData();
  },
  methods: {
    calculateTotal() {
      this.form.total_salary =
        (Number(this.form.host_salary) || 0) +
        (Number(this.form.agent_salary) || 0) +
        (Number(this.form.bd_salary) || 0);
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.policyId;
      axios
        .get(`/policies/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(
          `/policies/${this.$route.params.policyId}`,
          this.form
        );
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/module/${this.form.id}`,
          from_name: "PolicyIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/policies");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
